import api from '@/api/api.coffee'
import store from '@/store/store.coffee'
import axios from 'axios'
import qs from 'qs'
export default
  baseURL: -> 'https://api.onlineordersnow.com/'
  headers: -> { 'Content-Type': 'application/x-www-form-urlencoded' }
  getIncomingDomain: (url, subdomain) ->
    subdomain = subdomain || false
    url = url.replace(/(https?:\/\/)?(www.)?/i, '')
    url = url.split('.');
    if (url.indexOf('/') != -1)
      return url.split('/')[0]
    return url[0]
  database: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'databaseDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  staticMenu: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'staticMenus'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)

        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  instantWebsite: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'instantWebsiteDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)

        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderMethod: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderMethodDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)

        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  customer: ->
    byPhone: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'customerByPhone'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = response
      catch error
        response = { data: { error: error } }
    create: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'customerCreate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = response
      catch error
        response = { data: { error: error } }
    update: (customer) ->
      Data = Object.assign({}, customer)
      try
        response = await axios({
          url: api.baseURL() + 'customerUpdate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  verify: ->
    viaPhone: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'customerSendVerifyCodeViaPhone'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = response
      catch error
        response = { data: { error: error } }
    viaEmail: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'customerSendVerifyCodeViaEmail'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = response
      catch error
        response = { data: { error: error } }
    code: (customer) ->
      Data = Object.assign({}, customer)
      try
        response = await axios({
          url: api.baseURL() + 'customerVerifyCode'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    pin: (customer) ->
      Data = Object.assign({}, customer)
      try
        response = await axios({
          url: api.baseURL() + 'customerVerifyPin'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  order: ->
    create: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartCreate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    place: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderPlace'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    status: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderStatus'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    update: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderUpdate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    valid: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderValidate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderType: ->
    update: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'changeOrderType'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderLocation: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderLocations'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderItem: ->
    create: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemCreate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    update: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemUpdate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    delete: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemDelete'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    addModifier: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddModifier'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    removeModifier: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemRemoveModifier'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    modifierAddModifier: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemModifierAddModifier'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    modifierRemoveModifier: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemModifierRemoveModifier'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderRecommendationItem: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartRecommendationList'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderFeaturedItem: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartFeaturedItemList'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  prevOrder: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderHistory'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderMywayItem: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartMyWayList'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    delete: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'deleteCustomerMyWay'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderMenu: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderMenuList'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    thing: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderMenus'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderMenuDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  category: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderMenuCategories'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  categoryItem: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderMenuCategoryItems'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  menuItemGroup: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'orderMenuCategoryItemGroup'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  sendEmail: ->
    update: (object) ->
     Data = Object.assign({}, object)
     try
       response = await axios({
         url: api.baseURL() + 'updatesendemailflag'
         method: 'POST'
         headers: api.headers()
         data: qs.stringify(Data)
       })
       response = api.devalue(response)
     catch error
       response = { data: { error: error } }
  orderPaymentOptions: ->
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartPaymentOptionsAvailable'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderPayment: ->
    create: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartPaymentCreate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    void: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartPaymentVoid'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartPaymentDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  menuItem: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartMenuItemDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  coupon: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartCouponDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    apply: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartCouponApply'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    applyCode: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartCouponCodeApply'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    list: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartCouponList'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    staticList: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'staticCouponList'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  addon: ->
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddonDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  orderItemAddon: ->
    create: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddonCreate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    remove: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddonRemove'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    addFollowup: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddonAddFollowup'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    removeFollowup: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddonRemoveFollowup'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    addModifier: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddonAddModifier'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    removeModifier: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'cartItemAddonRemoveModifier'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
  translate: ->
    create: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'translationCreate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    details: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'translationDetails'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }
    update: (object) ->
      Data = Object.assign({}, object)
      try
        response = await axios({
          url: api.baseURL() + 'translationUpdate'
          method: 'POST'
          headers: api.headers()
          data: qs.stringify(Data)
        })
        response = api.devalue(response)
      catch error
        response = { data: { error: error } }

  antiCache: ->
    d = new Date()
    n = d.getTime()
    return '&anticache=' + n.toString()

  tryParseJSON: (jsonString) ->
    try
      o = JSON.parse(jsonString)
      # Handle non-exception-throwing cases:
      # Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      # but..JSON.parse(null) returns null, and typeof null === 'object',
      # so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if o != undefined && o != null && typeof o == 'object'
        return o
      return undefined
    catch e
      return undefined

  valueify: (data) ->
    if !data
      return ''
    if Object.keys(data).length == 0 && data.constructor == Object
      return ''
    if data.hasOwnProperty('value')
      return data.value
    return data

  devalue: (data) ->
    if !data
      return ''
    if Object.keys(data).length == 0 && data.constructor == Object
      return ''
    for keyi, key of Object.keys(data)
      data[key] = api.valueify(data[key])
      if data[key].constructor == Object
        data[key] = api.devalue(data[key])
       if data[key].constructor == Array
        data[key] = api.devalue(data[key])
    return data

  arrayify: (data) ->
    if !data
      return []
    if data == ''
      return []
    if data.constructor == Array
      return data
    return [ data ]

  indexify: (data) ->
    for index, item of data
      item.ID = index
    return data

  boolify: (value) ->
    if (typeof(value) == 'string')
      value = value.trim().toLowerCase()
    switch value
      when true
        return true
      when 'true'
        return true
      when 1
         return true
      when '1'
        return true
      when 'on'
        return true
      when 'yes'
        return true
      else
        return false

  munge: (data) ->
    return this.indexify(this.arrayify(this.valueify(data)))

  arrayToObjectArray: (tag, array) ->
    if array == undefined || array == null || array == ''
      return []
    d = []
    array.forEach (b, bi) ->
      obj = {}
      obj[tag] = b
      d.push obj
    return d

  uniqueIdOnlyArray: (array) ->
    return this.onePropertyOnlyArray('uniqueId', array)

  onePropertyOnlyArray: (tag, array) ->
    if array == undefined || array == null || array == ''
      return []
    d = []
    array.forEach (b, bi) ->
      obj = {}
      obj[tag] = b[tag]
      d.push obj
    return d

  axiosError: (error) ->
    if (error == undefined && error == '')
      return { error: 'Undefined Error' }
    if (error.response)
      return { error: error.response }
    if (error.request)
      return { error: error.request }
    return { error: error.message }

  jsonError: (response) ->
    if (response == undefined && response == '')
      return { error: 'Undefined Response' }
    if (response.data)
      if (response.data.error)
        return { error: response.data.error }
    return undefined

  googleError: (response) ->
    if (response == undefined && response == '')
      return { error: 'Undefined Response' }
    if (response.data)
      if (response.data.error_message)
        return { error: response.data }
    return undefined

  executeByName: (name, context = window) ->
    args = Array.prototype.slice.call(arguments, 2)
    normalizedName = name.replace(/[\]'"]/g, '').replace(/\[/g, '.')
    ns = normalizedName.split "."
    func = context
    for n, i in ns
      func = func[n]
    ns.pop()
    for n, i in ns
        context = context[n]
    if typeof func != 'function'
        throw new TypeError 'Cannot execute function ' + name
    return func.apply(context, args)
